// frontend/src/App.js
import React from 'react'
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import PicksPage from './pages/PicksPage'
import LeaderboardPage from './pages/LeaderboardPage'
import LoginPage from './pages/LoginPage'
import SignupPage from './pages/SignupPage'
import AdminPage from './pages/AdminPage'
import ProfilePage from './pages/ProfilePage'
import RankingsPage from './pages/RankingsPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import RequireAuth from './RequireAuth'

// Redirect /player/:username → /profile/:username
function PlayerRedirect() {
  const { username } = useParams()
  return <Navigate to={`/profile/${username}`} replace />
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/picks" element={<RequireAuth><PicksPage /></RequireAuth>} />
        <Route path="/picks/:basho/:day" element={<RequireAuth><PicksPage /></RequireAuth>} />
        <Route path="/leaderboard/:basho/:day" element={<RequireAuth><LeaderboardPage /></RequireAuth>} />
        <Route path="/admin" element={<RequireAuth><AdminPage /></RequireAuth>} />
        <Route path="/profile" element={<RequireAuth><ProfilePage /></RequireAuth>} />
        <Route path="/profile/:username" element={<RequireAuth><ProfilePage /></RequireAuth>} />
        <Route path="/rankings" element={<RequireAuth><RankingsPage /></RequireAuth>} />
        <Route path="/player/:username" element={<RequireAuth><PlayerRedirect /></RequireAuth>} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
